
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TimelineControlsProps {
  onScrollLeft: () => void;
  onScrollRight: () => void;
  canScrollLeft: boolean;
  canScrollRight: boolean;
}

export const TimelineControls: React.FC<TimelineControlsProps> = ({
  onScrollLeft,
  onScrollRight,
  canScrollLeft,
  canScrollRight
}) => {
  return (
    <>
      <div className="absolute left-4 bottom-[-1px] z-30 overflow-visible group">
        <Button 
          variant="outline" 
          size="icon"
          onClick={onScrollLeft}
          disabled={!canScrollLeft}
          className="rounded-full bg-background shadow-md w-7 h-7 sm:w-8 sm:h-8 overflow-visible group-[.overflow-visible]:z-50"
        >
          <ChevronLeft className="h-3 w-3 sm:h-4 sm:w-4" />
        </Button>
      </div>

      <div className="absolute right-4 bottom-[-1px] z-30 overflow-visible group">
        <Button 
          variant="outline" 
          size="icon"
          onClick={onScrollRight}
          disabled={!canScrollRight}
          className="rounded-full bg-background shadow-md w-7 h-7 sm:w-8 sm:h-8 overflow-visible group-[.overflow-visible]:z-50"
        >
          <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4" />
        </Button>
      </div>
    </>
  );
};
